import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "customer-groups-page" }
const _hoisted_2 = { class: "customer-groups-page__panel" }
const _hoisted_3 = {
  key: 0,
  class: "container-border container-border--error-info",
  role: "alert"
}
const _hoisted_4 = {
  key: 1,
  class: "container-border container-border--success-info",
  role: "status"
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "customer-groups-page__loading",
  "aria-live": "polite"
}
const _hoisted_7 = {
  key: 0,
  class: "customer-groups-page__panel"
}
const _hoisted_8 = { class: "customer-groups-page__results" }

import { computed, ref } from "vue";
import { useField, useForm } from "vee-validate";
import Input from "@components/Input/Input.vue";
import Spinner from "@components/Spinner/Spinner.vue";
import { useApi } from "@shared/Services/axios-service";

type UpgradeClubMemberLevelRequest = {
  seasonEndDate: string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerGroupsPage',
  setup(__props) {

const submitError = ref("");
const submitSuccess = ref("");
const messages = ref<string[]>([]);

const { handleSubmit } = useForm();
const { value: seasonEndDate, errorMessage: seasonEndDateError } = useField<string>(
  "seasonEndDate",
  (value?: string) => value ? true : "Du måste välja ett datum",
);

const { post, loading, errorMessage } = useApi<string[]>("/customergroups/upgradeclubmemberlevel");

const apiErrorText = computed(() => {
  const error = errorMessage.value;

  if (typeof error === "string") {
    return error;
  }

  if (error && typeof error === "object" && "message" in error) {
    const message = error.message;
    return Array.isArray(message) ? message.join(", ") : String(message ?? "");
  }

  return "";
});

const submit = handleSubmit(async () => {
  submitError.value = "";
  submitSuccess.value = "";
  messages.value = [];

  try {
    const response = await post<string[], UpgradeClubMemberLevelRequest>({
      seasonEndDate: seasonEndDate.value,
    });

    messages.value = response;
    submitSuccess.value = "Klubbnivåer uppdaterade.";
  } catch {
    submitError.value = apiErrorText.value || "Kunde inte uppdatera kundklubbsnivåer";
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("h1", null, "Kundklubbar", -1 /* CACHED */)),
      _cache[4] || (_cache[4] = _createElementVNode("p", null, "Uppdatera kundklubbsnivåer baserat på föregående säsongs slutdatum.", -1 /* CACHED */)),
      (submitError.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(submitError.value), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      (submitSuccess.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(submitSuccess.value), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("form", {
        class: "customer-groups-page__form",
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_unref(submit) && _unref(submit)(...args)), ["prevent"]))
      }, [
        _createVNode(Input, {
          modelValue: _unref(seasonEndDate),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(seasonEndDate) ? (seasonEndDate).value = $event : null)),
          id: "season-end-date",
          type: "date",
          label: "Föregående säsongs slutdatum",
          "is-invalid": !!_unref(seasonEndDateError),
          "error-message": _unref(seasonEndDateError)
        }, null, 8 /* PROPS */, ["modelValue", "is-invalid", "error-message"]),
        _createElementVNode("button", {
          class: "button button--large",
          type: "submit",
          disabled: _unref(loading)
        }, " Uppdatera kundklubbsnivåer ", 8 /* PROPS */, _hoisted_5),
        (_unref(loading))
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(Spinner),
              _cache[2] || (_cache[2] = _createElementVNode("span", null, "Uppdaterar...", -1 /* CACHED */))
            ]))
          : _createCommentVNode("v-if", true)
      ], 32 /* NEED_HYDRATION */)
    ]),
    (messages.value.length > 0)
      ? (_openBlock(), _createElementBlock("section", _hoisted_7, [
          _cache[5] || (_cache[5] = _createElementVNode("h2", null, "Resultat", -1 /* CACHED */)),
          _createElementVNode("ul", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messages.value, (message, index) => {
              return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(message), 1 /* TEXT */))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})